// @ts-nocheck

import React, { useState, useCallback } from 'react';
import { ListTable } from '../../components/ui';

import { vehicleTaxRateApi } from '../../lib/api';

import { formatDateTimeToString, navigate } from '../../lib/helpers';

import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import Grid, { GridItem } from '../../components/layout/Grid';
import { Card } from '../../components';

import { withUserAccess } from './../withUserAccess';

import { addAccessRight } from './accessRight';
import { getBreadCrumbsByUrlForCard } from '../../lib/autoBreadcrumbs';

const { Field } = Card;










const entryPointPath = '/admin/vehicle-tax-rate/';

const InnerForm = (props) => {
  return (
    <>
      <Grid gutter="16px">
        <GridItem>
          <Field label="Наименование объекта налогообложения">
            {props.data.name}
          </Field>
        </GridItem>
        <GridItem />
        <GridItem>
          <Field label="Дата начала">
            {formatDateTimeToString(props.data.startDate, 'DD.MM.YYYY')}
          </Field>
        </GridItem>
        <GridItem>
          <Field label="Дата окончания">
            {formatDateTimeToString(props.data.endDate, 'DD.MM.YYYY')}
          </Field>
        </GridItem>
        <GridItem fullWidth>
          <Field>
            <ListTable
              columns={[
              {
                title: 'Мощность двигателя от, л.с.',
                key: 'powerFrom'
              },
              {
                title: 'Мощность двигателя до, л.с.',
                key: 'powerTo'
              },
              {
                title: 'Налоговая ставка, руб',
                key: 'taxRate'
              }]
              }
              data={props.data.powerPeriodTaxRates} />

          </Field>
        </GridItem>
      </Grid>
    </>);

};

export default withUserAccess((props) => {
  const [data, setData] = useState({
    id: props.id,
    name: '',
    isAvailableForSelect: false
  });

  const breadCrumbs = getBreadCrumbsByUrlForCard(entryPointPath, data.id);

  const canEdit = props.userAccess.some((access) =>
  addAccessRight.includes(access)
  );

  const access = {
    delete: canEdit ?
    async () => {
      await vehicleTaxRateApi.delete(data.id);
      await navigate(`${entryPointPath}`, true);
    } :
    false,
    edit: canEdit ?
    async () => await navigate(`${entryPointPath}edit/${data.id}`) :
    false
  };

  const onFetch = useCallback(async () => {
    setData(await vehicleTaxRateApi.get(props.id));
  }, [props.id]);

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs,
        mainHeader: 'Налоговые коэффициенты для ТС',
        access
      }}
      onFetch={onFetch}>

      <InnerForm data={data} />
    </CommonCardPage>);

});
